import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'Is it paper or digital?',
    a: 'It is a 100% digital product (High-Resolution PDF) that combines 6 guides in 1, optimized for viewing on iPad, Tablet, or Smartphone during your classes.'
  }, {
    q: 'Do I need to be an expert to use it?',
    a: "No. It's designed to help both beginners looking for confidence and experienced instructors who want to save time. Every sequence is explained step by step."
  }, {
    q: 'Does it work for Reformer and Mat?',
    a: 'Yes. The volumes cover both modalities and the use of small props (bands, balls, rings).'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <div className="text-center mb-12" data-id="element-55">
          <div className="bg-pilates-sage/15 text-pilates-sage-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-56">
            Frequently Asked Questions
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight tracking-tight" data-id="element-57">
            Answering{' '}
            <span className="italic text-pilates-rose" data-id="element-58">your questions</span>
          </h2>
        </div>

        <div className="space-y-3" data-id="element-59">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-pilates-sage/20 overflow-hidden shadow-sm" data-id="element-60">
              <button onClick={() => setOpen(open === idx ? null : idx)} className="w-full flex items-center justify-between p-5 text-left hover:bg-pilates-cream/40 transition-colors" data-id="element-61">
                <span className="font-display font-semibold text-pilates-dark text-base sm:text-lg pr-4" data-id="element-62">
                  {faq.q}
                </span>
                <div className="flex-shrink-0 bg-pilates-sage-dark text-white w-8 h-8 rounded-full flex items-center justify-center" data-id="element-63">
                  {open === idx ? <Minus className="w-4 h-4" data-id="element-64" /> : <Plus className="w-4 h-4" data-id="element-65" />}
                </div>
              </button>
              {open === idx && <div className="px-5 pb-5 text-pilates-slate leading-relaxed" data-id="element-66">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}